import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { withIntl } from 'ha/i18n';
import {
  getCollectionFilter,
  getPriceFilter,
  getCityName,
  getCountryName,
  getCountryCode,
  getAdvertiserName,
  getPageInfo,
  getMap,
} from '../selectors';
import SearchMeta from '../components/SearchMeta';

const mapStateToProps = (state: GlobalState) => {
  const { latitude, longitude } = getMap(state);
  const { priceMax, priceMin, currency } = getPriceFilter(state);

  return {
    canonicalCollection: getCollectionFilter(state),
    priceMax,
    priceMin,
    currency,
    cityName: getCityName(state),
    countryName: getCountryName(state),
    countryCode: getCountryCode(state),
    advertiserName: getAdvertiserName(state),
    total: getPageInfo(state).total,
    latitude,
    longitude,
  };
};

export default withIntl(connect(mapStateToProps)(SearchMeta));
